function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDischargePoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-1-1",
    width: 19.84375,
    height: 19.84375,
    x: 0,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#4e79a7",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-2-2",
    width: 17.197918,
    height: 17.197918,
    x: 1.3229218,
    y: 278.47919
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.09085026,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0.66145494,283.63851 v 1.32292 H 2.9383149 c 0.7022,2.93029 0.17846,7.14375 6.98356,7.14375 6.8051011,0 6.2765911,-4.21516 6.9783811,-7.14375 h 2.28203 v -1.32292 h -2.11666 -1.058341 c -1.553479,0 -1.823489,1.51204 -3.042699,1.51204 -1.175311,0 -1.48921,-0.98287 -3.0427111,-0.98287 -1.55347,0 -1.97983,1.06209 -3.04271,0.98287 -1.12942,-0.0841 -1.48924,-1.51204 -3.04271,-1.51204 h -1.05833 z m 3.51922996,1.62773 c 1.47957,0.0526 1.24517,1.50698 2.69848,1.50698 1.48004,0 1.78787,-0.98287 3.04271,-0.98287 1.2987601,0 1.5626811,0.98287 3.0427111,0.98287 1.45175,0 1.219129,-1.45136 2.693989,-1.50698 -0.47219,2.56434 0.0795,5.51604 -5.7367001,5.51604 -5.81618,0 -5.26872,-2.95019 -5.74119,-5.51604 z",
    id: "rect13716-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 19.197791,289.71154 -6.626984,6.62699 h 1.122413 l 5.504571,-5.50404 z",
    id: "rect8773-0-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 19.197791,292.70567 -3.632853,3.63286 h 1.122413 l 2.51044,-2.51044 z",
    id: "rect8773-0-3-5-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 6.0905809,290.84533 -5.42912496,5.42912 v 0.0641 H 1.7197889 l 5.188315,-5.18832 z",
    id: "rect8773-0-3-4-26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 16.520954,284.331 c 0,0 0.0056,0.10406 0.01035,0.18913 l 0.189135,-0.18913 z m -8.0300011,7.10705 -4.900478,4.90048 h 1.122413 l 4.868437,-4.86844 z",
    id: "rect8773-0-3-5-23-25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 18.457786,284.46483 -2.15284,2.15336 -0.567923,1.69035 3.281968,-3.28198 z m -5.534546,6.6575 -1.711524,0.58859 -4.6271071,4.62761 h 1.122413 z",
    id: "rect8773-0-3-5-2-7-26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 19.197791,286.71844 -9.6200831,9.62009 h 1.1224131 l 8.49767,-8.49767 z",
    id: "rect8773-0-3-5-6-4-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 3.3031559,284.65242 -2.64169996,2.6417 v 1.12242 l 2.73419896,-2.73421 c -0.06331,-0.41492 -0.08622,-0.76554 -0.0925,-1.02991 z",
    id: "rect8773-0-3-4-1-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 3.7765119,287.17218 -3.11505596,3.11504 v 1.12242 l 3.46128696,-3.46128 c -0.137054,-0.25802 -0.250574,-0.51814 -0.346231,-0.77618 z",
    id: "rect8773-0-3-5-23-2-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 4.2561029,289.68609 -3.59464696,3.59476 v 1.12292 l 4.16928796,-4.16939 z",
    id: "rect8773-0-3-5-2-7-2-46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDischargePoint);
export default __webpack_public_path__ + "static/media/icon-discharge-point.f21e9a95ff4f3150f1233535119e9a05.svg";
export { ForwardRef as ReactComponent };